export interface FdicSavingsRateObservation {
    effectiveFromUtc: string;
    ratePct: number;
    releaseDate: string;
    note: string;
}

export const FDIC_SAVINGS_RATE_SOURCE_URL =
    "https://www.fdic.gov/national-rates-and-rate-caps/national-rates-and-rate-caps-previous-rates";

/**
 * FDIC national savings rates covering the available USDv APY history.
 *
 * The first observation anchors the benchmark to the beginning of the USDv
 * series using the latest FDIC rate published at that time. Later observations
 * take effect on their respective monthly FDIC release dates.
 */
export const FDIC_SAVINGS_RATE_HISTORY: readonly FdicSavingsRateObservation[] = [
    {
        effectiveFromUtc: "2025-06-04T13:51:53Z",
        ratePct: 0.42,
        releaseDate: "2025-05-19",
        note: "Latest published FDIC savings national deposit rate at APY history start"
    },
    {
        effectiveFromUtc: "2025-06-16T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2025-06-16",
        note: "June 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-07-21T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2025-07-21",
        note: "July 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-08-18T00:00:00Z",
        ratePct: 0.39,
        releaseDate: "2025-08-18",
        note: "August 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-09-15T00:00:00Z",
        ratePct: 0.4,
        releaseDate: "2025-09-15",
        note: "September 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-10-20T00:00:00Z",
        ratePct: 0.4,
        releaseDate: "2025-10-20",
        note: "October 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-11-17T00:00:00Z",
        ratePct: 0.4,
        releaseDate: "2025-11-17",
        note: "November 2025 monthly update"
    },
    {
        effectiveFromUtc: "2025-12-15T00:00:00Z",
        ratePct: 0.39,
        releaseDate: "2025-12-15",
        note: "December 2025 monthly update"
    },
    {
        effectiveFromUtc: "2026-01-20T00:00:00Z",
        ratePct: 0.39,
        releaseDate: "2026-01-20",
        note: "January 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-02-17T00:00:00Z",
        ratePct: 0.39,
        releaseDate: "2026-02-17",
        note: "February 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-03-16T00:00:00Z",
        ratePct: 0.39,
        releaseDate: "2026-03-16",
        note: "March 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-04-20T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2026-04-20",
        note: "April 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-05-18T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2026-05-18",
        note: "May 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-06-15T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2026-06-15",
        note: "June 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-07-20T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2026-07-20",
        note: "July 2026 monthly update"
    },
    {
        effectiveFromUtc: "2026-08-17T00:00:00Z",
        ratePct: 0.38,
        releaseDate: "2026-08-17",
        note: "August 2026 monthly update"
    }
];
